import type { SessionAdapter } from './session-adapter';
import type { SessionState } from './types';

export class LocalSessionAdapter implements SessionAdapter {
  private pendingTimer: ReturnType<typeof setTimeout> | null = null;
  private pendingState: SessionState | null = null;

  constructor(private userId: string) {
    const flush = () => {
      if (this.pendingState) this.flushNow(this.pendingState);
    };

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flush();
    });

    window.addEventListener('beforeunload', flush);
  }

  async load(): Promise<SessionState | null> {
    const raw = localStorage.getItem(`nula-session-${this.userId}`);
    if (!raw) return null;
    return JSON.parse(raw) as SessionState;
  }

  save(state: SessionState): void {
    this.pendingState = state;
    if (this.pendingTimer) return;
    this.pendingTimer = setTimeout(() => {
      this.pendingTimer = null;
      if (this.pendingState) this.flushNow(this.pendingState);
    }, 300);
  }

  private flushNow(state: SessionState): void {
    this.pendingState = null;
    localStorage.setItem(`nula-session-${this.userId}`, JSON.stringify(state));
  }
}
